export default __webpack_public_path__ + "static/media/info_icon.e97b465b.svg";